import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TableDialogService } from '@pg-app/partner/dashboard/services/table-dialog.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'np-funnel-modal',
  templateUrl: './funnel-modal.component.html',
  styleUrls: ['./funnel-modal.component.scss']
})
export class FunnelModalComponent implements OnDestroy, AfterViewInit {
  @ViewChild('tabs', {static: true}) tabs;
  subscription: Subscription;
  data: any;
  type = '';

  constructor(
    private tableDialogService: TableDialogService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog) { }

  ngAfterViewInit() {
    this.subscription = this.tableDialogService.TableOpportunityDialogSelectedSubject.subscribe(data => {
      this.type = data.Type;
      this.tabs.select('funnel_opportunity');
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public closeDialog() {
    this.dialog.closeAll();
  }
}
